export default () => ({
	message: '',
	payments: [],
	loading: false,
	loadingSave: false,
	paymentsForMonth: [],
});
